// ============================================================
// FILE: BookingRow.js
// LOCATION: C:\gardenmarket\web\src\pages\gardener\BookingRow.js
// ============================================================
// PURPOSE:
//   One row in the My Bookings list (gardener side). Same
//   redesign as JobRow.js — open rows, soft selected tint,
//   pastel status badges, theme.js tokens throughout.
//
// USED BY:
//   MyBookings.js — rendered inside MasterDetailLayout
// ============================================================

import { listRow, rowTitle, rowSubtitle, rowDate, statusPill, colors } from '../../theme/theme';

export default function BookingRow({ job: b, isSelected, onClick }) {
    const showsReviewColumn = ['completed', 'reviewed'].includes(b.status_code);

    return (
        <tr onClick={onClick} style={listRow(isSelected)}>
            <td style={rowDate}>
                {b.preferred_date ? new Date(b.preferred_date).toLocaleDateString('en-AU', { day:'numeric', month:'short' }) : '—'}
            </td>
            <td style={{overflow:'hidden'}}>
                <div style={rowTitle}>{b.title}</div>
                <div style={rowSubtitle}>{b.buyer_name}</div>
            </td>
            <td style={{verticalAlign:'top'}}>
                <span style={statusPill(b.status_code)}>{b.status_label}</span>
                {showsReviewColumn && (
                    <div style={styles.reviewLine}>
                        {b.status_code === 'reviewed'
                            ? <span style={{color: colors.brand}}>✓ Reviewed</span>
                            : <span style={{color: colors.textFaint}}>Awaiting review</span>}
                    </div>
                )}
            </td>
        </tr>
    );
}

const styles = {
    reviewLine: { fontSize:'0.68rem', marginTop:'4px' },
};
